import React from 'react';
import {
  Spinner,
  mergeClasses,
} from '@fluentui/react-components';

import { useStyles } from './styles';

interface UiBlockerProps {
  className?: string;
  classes?: {
    root?: string;
  };
  blocking: boolean;
  loadingText?: string;
  labelPosition?: 'before' | 'after' | 'above' | 'below';
  spinnerSize?: 'small' | 'medium' | 'large' | 'tiny' | 'extra-small' | 'extra-large' | 'huge' | 'extra-tiny';
  children: React.ReactNode;
}

export const UiBlocker: React.FC<UiBlockerProps> = (props) => {
  const {
    blocking,
    loadingText,
    labelPosition,
    spinnerSize,
    children,
  } = props;

  const className = blocking ? 'react-block-ui' : 'react-block-ui-none';
  const classes = useStyles();

  return (
    <div className={mergeClasses('ui-blocker-container', className, classes.blockUiContainer, props.className, props.classes?.root)} aria-busy={blocking}>
      {children}
      {blocking
        && (
          <div className={mergeClasses(classes.blockUiOverlay, 'ui-blocker-overlay')}>
            <div
              className={mergeClasses(classes.blockerIndicator, 'ui-blocker-indicator')}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              aria-label={loadingText}
            >
              <Spinner className="ui-blocker-spinner" size={spinnerSize} label={loadingText} labelPosition={labelPosition} />
            </div>
          </div>
        )}
    </div>
  );
};

UiBlocker.defaultProps = {
  className: '',
  loadingText: undefined,
  labelPosition: 'after',
  spinnerSize: 'medium',
};
